import { render } from "./SupportBlock.vue?vue&type=template&id=d1e906c8&scoped=true"
import script from "./SupportBlock.vue?vue&type=script&lang=js"
export * from "./SupportBlock.vue?vue&type=script&lang=js"

import "./SupportBlock.vue?vue&type=style&index=0&id=d1e906c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e906c8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
